import { render, staticRenderFns } from "./PaymentHistoryCard.vue?vue&type=template&id=32b24525"
import script from "./PaymentHistoryCard.vue?vue&type=script&lang=js"
export * from "./PaymentHistoryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports